/** Selection/hover tint — brand blue at ~8%, subtler than Joy's default softBg.
 *  FAINT is the row-hover shade: Joy's default hoverRow gray reads as a heavy
 *  slab across the wide library pane; hover/selected/drag share one hue.
 *  This file is the only place a row interaction wash is written — every
 *  table/row that needs hover, selected, or drag-over shading imports from here.
 *  Derived from the theme's `primary.mainChannel` (auto-computed by Joy's
 *  `extendTheme` from `primary.500`), so these track the theme's primary
 *  color automatically instead of restating the hex as an rgba literal. */
export const SELECTION_TINT_FAINT = "rgba(var(--joy-palette-primary-mainChannel) / 0.04)";
export const SELECTION_TINT = "rgba(var(--joy-palette-primary-mainChannel) / 0.08)";
